<template>
    <div class="privacy">
        <h3>Privacy Policy for iOS APP</h3>
        <h4>Collection of your Personal Information</h4>
        <p>
            Application may collect personally identifiable information, such as your name. If you purchase our products and services, Application collect billing and credit card information. This information is used to complete the purchase transaction. All of this information is what you enter into required or optional fields when making a purchase or opting-in to a subscription. We may gather additional personal or non-personal information in the future. Information about your computer hardware and software may be automatically collected by us. This information can include: your IP address, browser type, domain names, access times, and referring website addresses. This information is used to maintain optimum service quality and to provide general statistics regarding use of the website. Please keep in mind that if you directly disclose personally identifiable information or personally sensitive data through our public message boards, this information may be collected and used by others, We are not liable for publicly posted information. We encourages you to review the privacy statements of websites you choose to link to from us so that you can understand how those websites collect, use and share your information.We are not responsible for the privacy statements or other content on websites outside of the website.
        </p>
        <h4>Use of your Personal Information</h4>
        <p>
            Application collects and uses your personal information to operate its website(s) and deliver the services you have requested. Application may also use your personally identifiable information to inform you of other products or services available from us and its affiliates that you may be interested in. We may also contact you via surveys to conduct research about your opinion of current services or of potential new services that may be offered. We does not sell, rent, or lease its customer lists to third parties.We may share data with trusted partners to help perform statistical analysis, send you email or postal mail, provide customer support, or arrange for deliveries. All such third parties are prohibited from using your personal information except to provide these services to Us, and they are required to maintain the confidentiality of your information. We may keep track of the websites and pages our users visit within us, in order to determine what our services are the most popular. This data is used to deliver customized content and advertising within us to customers whose behavior indicates that they are interested in a particular subject area. We will disclose your personal information, without notice, only if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served on us or the site; (b) protect and defend the rights or property of us; and, (c) act under exigent circumstances to protect the personal safety of users of us, or the public.
        </p>
        <h4>
            Use of Cookies
        </h4>
        <p>
            The website may use "cookies" to help you personalize your online experience. A cookie is a text file that is placed on your hard disk by a web page server. Cookies cannot be used to run programs or deliver viruses to your computer. Cookies are uniquely assigned to you, and can only be read by a web server in the domain that issued the cookie to you. One of the primary purposes of cookies is to provide a convenience feature to save you time. The purpose of a cookie is to tell the Web server that you have returned to a specific page. For example, if you personalize our pages, or register with our site or services, a cookie helps us to recall your specific information on subsequent visits. This simplifies the process of recording your personal information, such as billing addresses, shipping addresses, and so on. When you return to the same website, the information you previously provided can be retrieved, so you can easily use our features that you customized. You have the ability to accept or decline cookies. Most Web browsers automatically accept cookies, but you can usually modify your browser settings to decline cookies if you prefer. If you choose to decline cookies, you may not be able to fully experience the interactive features of our services and/or website.
        </p>
        <h4>
            Security of your Personal Information
        </h4>
        <p>
            To secure your personal information from unauthorized access, use or disclosure, Application uses Digicert when personal information (such as a credit card number) is transmitted to other websites, it is protected through the use of encryption, such as the Secure Sockets Layer (SSL) protocol. Protect your password and computer, do not let unauthorized users have access to your account information. When using a shared or public computer, remember to sign out.
        </p>
        <h4>
            Under-Age Use
        </h4>
        <p>
            Application do not knowingly collect personally identifiable information from children under the age of eighteen. If you are under the age of eighteen, you must ask your parent or guardian for permission to use this website.
        </p>
        <h4>
            Opt-Out & Unsubscribe
        </h4>
        <p>
            We respect your privacy and give you an opportunity to opt-out of receiving announcements of certain information. Users may opt-out of receiving any or all communications from us at any time by contacting customer service at info@lefu.cc.
        </p>
        
        <h4>
            Third Party Advertisers
        </h4>
        <p>Application provides internet based ads for its customers to try to find other products or services that they may be interested in. Internet based advertisers do not receive any customer’s personal information from us. Application uses the automatic information gathered by cookies in order to provide advertisements relevant to each customer. The advertisements that are displayed on lefu.cc are not affiliated with us and We are not liable for any third party advertisements or content displayed on third party sites.</p>
        <h4>
            About Healthkit
        </h4>
        <p>
            When you use Application, if you allow the data to be written to Healthkit:We will not use the data collected by HealthKit for advertising or similar services.We will not display any data collected by HealthKit to third parties without the permission of the user.We will not sell data collected by HealthKit to advertising platforms, data agents, or information dealers.Only under user's permission, we may share HealthKit data with third parties for medical research.  We will not save data to icloud.
        </p>
        <h4>
            引言(中文版）
        </h4>
        <p>
            您在使用应用程序时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用应用程序时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的应用程序息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。
        </p>
        <p>
            您使用或继续使用应用程序，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。
        </p>
        <h4>
            我们可能收集的信息
        </h4>
        <p>
            我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法享受我们提供的服务，或者无法达到相关服务拟达到的效果。
        </p>
        <h4>
            您提供的信息：
        </h4>
        <p>
            您在使用应用程序时，向我们提供的相关个人信息，例如身高、出生日期、性别等；您通过应用程序向其他方提供的共享信息，以及您使用应用程序时所储存的信息，例如您允许了将数据写入Healthkit。
        </p>
        <h4>
            我们可能分享的信息
        </h4>
        <p>
            除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享、出售您的个人信息：向您提供我们的服务；您允许了将数据写入Healthkit；
        </p>
        <h4>
            关于Healthkit
        </h4>
        <p>
            在您使用应用程序时，如果您您允许了将数据写入Healthkit：我们不会将HealthKit收集的数据用于广告或类似的服务。在没有用户的明确允许下，我们不会向第三方展示任何HealthKit收集的数据。我们不会将HealthKit收集的数据出售给广告平台、数据代理人或者信息经销商。如果用户允许，我们可以将HealthKit数据共享给第三方用于医学研究。我们不会将数据保存到icloud。
        </p>
        <h4>
            iOSアプリのプライバシーポリシー
        </h4>
        <p>
            応用のサービスをご利用頂く際、お客様の関連情報を収集し使用する場合があります。このプライバシーポリシーを通じて、当社のサービスご利用時、お客様関連情報をどのように収集、使用、保存、共有するか、またカメラの位置情報、呼び出し、情報ファイルの読み取りと書き込みの使用について、及び当社がお客様に提供するアクセス、更新、制御、保護これらの情報方式についてご説明致します。
        </p>
        <p>
            このプライバシーポリシーは、お使いのサービスと密接に関連しております。そのためよく読んで頂き、必要に応じて本プライバシーポリシーのガイドラインに沿って適切な判断をお願い致します。
        </p>
        <p>
            お客様が当社サービスをご利用・継続利用頂くことは、当社がこのプライバシーポリシーの基づき、お客様の関連情報を収集、使用、保存、共有することに同意することを意味します
        </p>
        <p>
            当社がお客様にサービスを提供する際、お客様に関連する情報を収集、保存、使用することがあります。お客様が関連情報を提供頂けない場合、弊社の提供するサービスをご利用頂けない、もしくはサービスの一部をご利用頂けない場合がございます。
        </p>
        <h4>
            お客様が提供する情報
        </h4>
        <p>
            測定項目:体重、水分、脂肪率、筋肉含量、骨量、内臓脂肪ランク、BMI,BMR携帯情報:測定時間、登録情報、登録時間、IP、Macアドレス、型番、製造メーカー、操作システムその他: 身長、年齢、性別、ユーザー名
        </p>
        <h4>
            承諾:
        </h4>
        <p>
            関連法令、法律、政府からの強制的な要求を除き、お客様の同意なしに個人情報を第三者に共有または販売することはございません。
        </p>
        <h4>
            許可される必要な権限:
        </h4>
        <p>
            カメラ、位置情報サービス、ダイヤル通話、ファイル関連のアクセスの読み取りと書き込み
        </p>
        <h4>
            あなたの情報の使い方：
        </h4>
        <p>
            APP、Alibaba Cloudデータ保管のサービスを提供する。新しいサービスの設計、既存のサービスを改善する
        </p>
        <h4>
            HealthKit について
        </h4>
        <p>
            応用のサービスを利用する際に、HealthKit にデータを書き込むことを許可している場合:•広告などのサービスにHealthKitから収集されたデータを使用しません。•ユーザーの明示的な許可なしに、HealthKitから収集されたデータを第三者に表示、提供することは一切ありません。•広告プラットフォーム、データエージェントまたは情報流通業者にHealthKitから収集されたデータを販売することはありません。•ユーザーが許可する場合、医療研究のためにHealthKitデータを第三者に共有することができます。• icloud にデータを保存することはありません。
        </p>

        <h3>
        Privacy Policy for Android APP
        </h3>
        <h4>
        Introduction
        </h4>
        <p>
           Application may collect and use your related information when you choose our service. Through this Privacy Policy, we hope that guiding you know how we collect, use, store and share these information while using our service. Also we will provide the ways of visit, integrate and protect these information. The Privacy Policy is related to service which provided by Shenzhen Unique Scales Co., Ltd. Hope you read it carefully and make the best suitable choice according to the guidelines of the Privacy Policy when needed.     
        </p>
        <p>
           If you using or continue using our service, it means that you agree with that we collect, use, store and share your related information obey to this Privacy Policy.
        </p>
        <h4>
            The information we may collect
        </h4>
        <p>
            It may need to collect, store and use the following information related with you when we provide the service. If you don’t provide related information, you maybe can’t enjoy the service we provided. Or it maybe can’t reach to the effect with related service.
        </p>
        <h4>
            The information you need to provide:
        </h4>
        <p>
            When you using Application, there need to provide your related information such as height, birthday, gender etc..Providing shared information to other parties through our service. Information will be stored when using our service. For example, you will be allowed to input your data to APP.
        </p>
        <h4>
            The information we may share
        </h4>
        <p>
           All information will not be shared or sold to third parties if we and our related company did not obtain your permission, except for the situations as below:. Proving our APP service to you; You allow the camera, location service, make phone calls, read and write file related permissions.
        <h4>
            About
        </h4>
        <p>
            When you using the Application from Shenzhen Unique Scales Co., Ltd., if you allow the camera, location service, make phone calls, read and write file related permissions.
        </p>
        <p>
            a) Application will not use collected data used for advertising or similar services.b) In the absence of a user's explicit permission, Application will not show any data to third parties.c) Application will not use collected data from Application to be sold to the advertising platform, data information agent or dealer.d) If the user allows, Application will use collected data from Application shared with third parties for medical research.
        </p>
    
        <h4>
            引言(中文版）
        </h4>
        <p>
            您在使用应用程序时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用应用程序时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的应用程序息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。
        </p>
        <p>
            您使用或继续使用应用程序，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。
        </p>
        <h4>
            我们可能收集的信息
        </h4>
        <p>
            我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法享受我们提供的服务，或者无法达到相关服务拟达到的效果。
        </p>
        <h4>
            您提供的信息：
        </h4>
        <p>
            您在使用应用程序时，向我们提供的相关个人信息，例如身高、出生日期、性别等；您通过应用程序向其他方提供的共享信息，以及您使用我们的服务时所储存的信息，例如您允许了将数据写入Healthkit。
        </p>
        <h4>
            我们可能分享的信息
        </h4>
        <p>
            除以下情形外，未经您同意，我们以及我们的关联公司不会与任何第三方分享、出售您的个人信息：向您提供我们的服务；您允许了将数据写入Healthkit；
        </p>

        <h4>
            iOSアプリのプライバシーポリシー
        </h4>
        <p>
            応用のサービスをご利用頂く際、お客様の関連情報を収集し使用する場合があります。このプライバシーポリシーを通じて、当社のサービスご利用時、お客様関連情報をどのように収集、使用、保存、共有するか、またカメラの位置情報、呼び出し、情報ファイルの読み取りと書き込みの使用について、及び当社がお客様に提供するアクセス、更新、制御、保護これらの情報方式についてご説明致します。
        </p>
        <p>
            このプライバシーポリシーは、お使いのサービスと密接に関連しております。そのためよく読んで頂き、必要に応じて本プライバシーポリシーのガイドラインに沿って適切な判断をお願い致します。
        </p>
        <p>
            お客様が当社サービスをご利用・継続利用頂くことは、当社がこのプライバシーポリシーの基づき、お客様の関連情報を収集、使用、保存、共有することに同意することを意味します
        </p>
        <p>
            当社がお客様にサービスを提供する際、お客様に関連する情報を収集、保存、使用することがあります。お客様が関連情報を提供頂けない場合、弊社の提供するサービスをご利用頂けない、もしくはサービスの一部をご利用頂けない場合がございます。
        </p>
        <h4>
            お客様が提供する情報
        </h4>
        <p>
            測定項目:体重、水分、脂肪率、筋肉含量、骨量、内臓脂肪ランク、BMI,BMR携帯情報:測定時間、登録情報、登録時間、IP、Macアドレス、型番、製造メーカー、操作システムその他: 身長、年齢、性別、ユーザー名
        </p>
        <h4>
            承諾:
        </h4>
        <p>
            関連法令、法律、政府からの強制的な要求を除き、お客様の同意なしに個人情報を第三者に共有または販売することはございません。
        </p>
        <h4>
            許可される必要な権限:
        </h4>
        <p>
            カメラ、位置情報サービス、ダイヤル通話、ファイル関連のアクセスの読み取りと書き込み
        </p>
        <h4>
            あなたの情報の使い方：
        </h4>
        <p>
            APP、Alibaba Cloudデータ保管のサービスを提供する。新しいサービスの設計、既存のサービスを改善する
        </p>
     
    </div>
</template>
<script>
export default {
    
}
</script>
<style>
.privacy {
    padding: .3rem;
}
p{
    text-align: left;
    font-size: .3rem;
    line-height: .44rem;
}
h3 {
    font-size: .52rem;
}
h4 {
    font-size: .4rem;
}
li{
    text-align: left;
    font-size: .28rem;
}
</style>

